import { round } from 'lodash';

export default function measureImagePreviewWidthCssPx(
  editorRoot: HTMLElement,
  blockId: string,
) {
  const escapedId =
    typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
      ? CSS.escape(blockId)
      : blockId;
  const blockEl = editorRoot.querySelector(`[data-id="${escapedId}"]`);

  if (!blockEl) {
    return null;
  }

  const image = blockEl.querySelector('[data-content-type="image"] img');

  if (!(image instanceof HTMLImageElement)) {
    return null;
  }

  if (!image.complete || image.naturalWidth === 0) {
    return null;
  }

  const width = image.offsetWidth || image.clientWidth;

  if (width <= 0) {
    return null;
  }

  return round(width);
}
